// UrduPDFExport.js
import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import html2canvas from "html2canvas";
import axios from "axios";
import logoLeft from "../../assets/img/logo/new-logo.png";
import logoRight from "../../assets/img/logo/punjab-logo.png";

const UrduPDFExport = () => {
  const urduRef = useRef();
  const englishRef = useRef();
  const [entries, setEntries] = useState([]);
  const [urduData, setUrduData] = useState([]);
  const [filterDate, setFilterDate] = useState("");
  const [readableDate, setReadableDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 16;
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const urduButtonRef = useRef();
  const englishButtonRef = useRef();
  const totalPages = Math.ceil(entries.length / pageSize);


  useEffect(() => {
  if (startDate && endDate) {
    setCurrentPage(1);
    fetchDataBetweenDates(startDate, endDate);
    const formatted = `${new Date(startDate).toLocaleDateString("ur-PK")} - ${new Date(endDate).toLocaleDateString("ur-PK")}`;
    setReadableDate(formatted);
  }
}, [startDate, endDate]);


  useEffect(() => {
    if (filterDate) {
      setCurrentPage(1);
      fetchData(filterDate);
      const formatted = new Date(filterDate).toLocaleDateString("ur-PK", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      setReadableDate(formatted);
    }
  }, [filterDate]);


  const fetchDataBetweenDates = async (start, end) => {
  try {
    setLoading(true);
    const res = await axios.get(`https://ricgop.online/backend/getAmsBetweenDates.php?start=${start}&end=${end}`);
    if (Array.isArray(res.data)) {
      const translated = await Promise.all(
        res.data.map(async (entry, index) => {
          const urduDay = await translateText(entry.days);
          const urduEvening = await translateText(entry.evening_text);
          return {
            ...entry,
            urduDay,
            urduEvening,
            no: index + 1,
            name: entry.name || "-",
            contact: entry.contact || "-",
            on_call: entry.evening_text || "-",
          };
        })
      );
      setEntries(translated);
      setUrduData(translated);
    }
    setLoading(false);
  } catch (error) {
    console.error("Failed to fetch AMS data", error);
    setLoading(false);
  }
};


  const fetchData = async (date) => {
    try {
      setLoading(true);
      const res = await axios.get(`https://ricgop.online/backend/getAmsByDate.php?date=${date}`);
      if (Array.isArray(res.data)) {
        const translated = await Promise.all(
          res.data.map(async (entry, index) => {
            const urduDay = await translateText(entry.days);
            const urduEvening = await translateText(entry.evening_text);
            return {
              ...entry,
              urduDay,
              urduEvening,
              no: index + 1,
              name: entry.name || "-",
              contact: entry.contact || "-",
              on_call: entry.evening_text || "-",
            };
          })
        );
        setEntries(translated);
        setUrduData(translated);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch AMS data", error);
      setLoading(false);
    }
  };

  const translateText = async (text) => {
    if (!text) return "";
    try {
      const res = await fetch(
        `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=ur&dt=t&q=${encodeURIComponent(text)}`
      );
      const json = await res.json();
      return json?.[0]?.map((part) => part[0]).join(" ") || text;
    } catch {
      return text;
    }
  };


  

const handleScreenshotWithoutButton = async (targetRef, buttonRef, filename) => {
  if (!targetRef.current) return;

  // Hide the button temporarily
  if (buttonRef?.current) buttonRef.current.style.display = "none";

  await new Promise((resolve) => setTimeout(resolve, 100));

  try {
    const canvas = await html2canvas(targetRef.current, {
      scale: 2,
      useCORS: true,
      scrollY: -window.scrollY,
    });

    const imgData = canvas.toDataURL("image/jpeg", 1.0);
    const pdf = new jsPDF("portrait", "mm", "a4"); // ✅ use portrait mode

    const pageWidth = pdf.internal.pageSize.getWidth();   // ≈ 210mm
    const pageHeight = pdf.internal.pageSize.getHeight(); // ≈ 297mm

    const imgProps = pdf.getImageProperties(imgData);
    const pxToMm = (px) => px * 25.4 / 96;

    const imgWidthMm = pxToMm(imgProps.width);
    const imgHeightMm = pxToMm(imgProps.height);

    const scale = Math.min(pageWidth / imgWidthMm, pageHeight / imgHeightMm);
    const scaledWidth = imgWidthMm * scale;
    const scaledHeight = imgHeightMm * scale;

    const x = (pageWidth - scaledWidth) / 2;
    const y = (pageHeight - scaledHeight) / 2;

    pdf.addImage(imgData, "JPEG", x, y, scaledWidth, scaledHeight);
    pdf.save(filename);
  } catch (error) {
    console.error("PDF generation failed:", error);
  }

  // Restore the button
  if (buttonRef?.current) buttonRef.current.style.display = "inline-block";
};

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const renderDoubleTableRows = (data, isUrdu = false) => {
    const rows = [];
    for (let i = 0; i < data.length; i += 2) {
      const left = data[i];
      const right = data[i + 1];
      rows.push(
        <tr key={i} style={{ backgroundColor: i % 4 === 0 ? "#f1f1f1" : "#fff" }}>
          <td>{left?.no}</td>
          <td>{left?.date}</td>
          <td>{isUrdu ? left?.urduDay : left?.days}</td>
          <td>{isUrdu ? left?.urduEvening : left?.evening_text}</td>
          {right ? (
            <>
              <td>{right.no}</td>
              <td>{right.date}</td>
              <td>{isUrdu ? right.urduDay : right.days}</td>
              <td>{isUrdu ? right.urduEvening : right.evening_text}</td>
            </>
          ) : (
            <><td colSpan="4">-</td></>
          )}
        </tr>
      );
    }
    return rows;
  };

  const paginatedUrduData = urduData.slice((currentPage - 1) * pageSize, currentPage * pageSize);
  const paginatedEnglish = entries.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  return (
    <div>
               {/* 🔷 Responsive Navbar */}
    <nav className="navbar navbar-expand-lg bg-white shadow-sm px-4 py-3 mb-4 rounded-bottom-4">
      <div className="container-fluid">
        <a className="navbar-brand fw-bold text-primary fs-4" href="/">
          🏥 RIC Duty Panel
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarContent">
          <ul className="navbar-nav ms-auto align-items-center gap-lg-3 mt-3 mt-lg-0">

            {/* 🔽 Roasters Dropdown */}
            <li className="nav-item dropdown">
              <button
                className="btn btn-outline-secondary dropdown-toggle rounded-3 w-100"
                type="button"
                id="roastersDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                📁 Roasters
              </button>
              <ul className="dropdown-menu" aria-labelledby="roastersDropdown">
                <li><a className="dropdown-item" href="/entry/roaster/dutylist">Part 1 Duty Roaster</a></li>
                <li><a className="dropdown-item" href="/entry/roaster/ams">AMS Roaster</a></li>
                <li><a className="dropdown-item" href="/entry/roaster/vvip">VVIP Movement Roaster</a></li>
              </ul>
            </li>

            {/* 📋 Duty Forms */}
            <li className="nav-item">
              <button
                className="btn btn-outline-primary rounded-3 w-100"
                onClick={() => window.location.href = "/entry/roaster/dutyform"}
              >
                📋 Duty Forms
              </button>
            </li>

            {/* 🚪 Logout */}
            <li className="nav-item">
              <button
                className="btn btn-outline-danger rounded-3 w-100"
                onClick={() => {
                  localStorage.clear();
                  window.location.href = "/roaster/login";
                }}
              >
                🚪 Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
   
  <div style={{ fontFamily: "'Jameel Noori Nastaleeq', serif", backgroundColor: "#f8f9fa", padding: 20 }}>
  {/* Date Filter Row */}
  <div style={{ display: "flex", justifyContent: "center", margin: "20px 0", gap: 20 }}>
    <div>
      <label>📅 فلٹر تاریخ سے:</label><br />
      <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
    </div>
    <div>
      <label>📅 فلٹر تاریخ تک:</label><br />
      <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
    </div>
  </div>

  {/* Urdu Buttons */}
 <div
  style={{
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    marginBottom: "30px",
    marginTop: "10px",
  }}
>
  {/* Urdu Button */}
  <button
    ref={urduButtonRef}
    onClick={() => {
      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];
      handleScreenshotWithoutButton(
        urduRef,
        urduButtonRef,
        `AMS_URDU_${formattedDate}.pdf`
      );
    }}
    style={{
      backgroundColor: "#d63384", // Rose
      color: "#fff",
      border: "none",
      padding: "10px 20px",
      borderRadius: "8px",
      fontSize: "14px",
      cursor: "pointer",
      fontWeight: "bold",
      transition: "all 0.3s ease",
    }}
    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#c21870")}
    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#d63384")}
  >
    📄 Export In Urdu
  </button>

  {/* English Button */}
  <button
    ref={englishButtonRef}
    onClick={() => {
      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];
      handleScreenshotWithoutButton(
        englishRef,
        englishButtonRef,
        `AMS_ENGLISH_${formattedDate}.pdf`
      );
    }}
    style={{
      backgroundColor: "#0d6efd", // Bootstrap Primary
      color: "#fff",
      border: "none",
      padding: "10px 20px",
      borderRadius: "8px",
      fontSize: "14px",
      cursor: "pointer",
      fontWeight: "bold",
      transition: "all 0.3s ease",
    }}
    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#0b5ed7")}
    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#0d6efd")}
  >
    📄 Export In English
  </button>
</div>

</div>

<div
  ref={urduRef}
  style={{
    background: "white",
    padding: "30px",
    borderRadius: "10px",
    position: "relative",
    fontFamily: "'Jameel Noori Nastaleeq', serif",
    direction: "rtl",
    width: "794px",        // A4 portrait width at 96 DPI
    minHeight: "1123px",   // A4 portrait height
    margin: "0 auto",
    boxShadow: "0 0 10px rgba(0,0,0,0.2)",
  }}
>
  {/* Header */}
  <div
    style={{
      backgroundColor: "#e9f2ff",
      border: "2px solid #0d6efd",
      padding: "20px",
      borderRadius: "10px",
      marginBottom: "20px",
      position: "relative",
      textAlign: "center",
      color: "#000",
      fontWeight: "bold",
    }}
  >
    <img src={logoRight} alt="right" style={{ height: 80, position: "absolute", top: 10, right: 20 }} />
    <img src={logoLeft} alt="left" style={{ height: 80, position: "absolute", top: 10, left: 20 }} />
    <h3 style={{ marginTop: 0, fontSize: "22px" }}>دفتر میڈیکل سپرنٹنڈنٹ</h3>
    <p style={{ margin: 0 }}>راولپنڈی انسٹیٹیوٹ آف کارڈیالوجی، راول روڈ، راولپنڈی</p>
    <p style={{ margin: "5px 0" }}>RIC/Admin/ ____________/2025</p>
    <p style={{ margin: "5px 0" }}>تاریخ: ___ / ___ / 2025</p>
  </div>

  <div
    style={{
      backgroundColor: "#d1e7dd",
      border: "1px solid #198754",
      padding: "15px",
      borderRadius: "8px",
      textAlign: "center",
      marginBottom: "30px",
      color: "#0f5132",
    }}
  >
    <h4 style={{ fontWeight: "bold", fontSize: "18px", margin: "0" }}>اے ایم ایس / اے پی ڈبلیو ایم او ایوننگ ڈیوٹی روسٹر</h4>
    <p style={{ margin: "5px 0", fontSize: "16px" }}>📅 {readableDate}</p>
  </div>

  {/* Table */}
  <table
    style={{
      width: "100%",
      borderCollapse: "collapse",
      fontSize: "11px",
      tableLayout: "fixed",
    }}
  >
    <thead style={{ backgroundColor: "#0d6efd", color: "#fff" }}>
      <tr>
        {/* First Column Set */}
        <th style={{ width: "30px", border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>نمبر</th>
        <th style={{ width: "90px", border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>تاریخ</th>
        <th style={{ width: "80px", border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>دن</th>
        <th style={{ width: "166px", border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>ڈیوٹی</th>

        {/* Second Column Set */}
        <th style={{ width: "30px", border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>نمبر</th>
        <th style={{ width: "90px", border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>تاریخ</th>
        <th style={{ width: "80px", border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>دن</th>
        <th style={{ width: "166px", border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>ڈیوٹی</th>
      </tr>
    </thead>
    <tbody>
      {loading ? (
        <tr>
          <td colSpan="8" style={{ textAlign: "center", padding: "20px" }}>
            ⏳ لوڈ ہو رہا ہے...
          </td>
        </tr>
      ) : (
        renderDoubleTableRows(paginatedUrduData, true)
      )}
    </tbody>
  </table>

{/* Urdu Footer Container */}
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: "50px",
    padding: "0 30px",
    fontSize: "11px",
    direction: "rtl",
  }}
>
  {/* Note Section - Right */}
  <div style={{ width: "65%", textAlign: "right", lineHeight: "1.8" }}>
    <p style={{ fontWeight: "bold", marginBottom: "8px" }}>نوٹ:</p>
    <p style={{ margin: 0 }}>1۔ یہ روسٹر عارضی ہے اور بغیر اطلاع تبدیل ہو سکتا ہے۔</p>
    <p style={{ margin: 0 }}>2۔ تمام اسٹاف اپنی ڈیوٹی بروقت سرانجام دیں۔</p>
    <p style={{ margin: 0 }}>3۔ غیر حاضری یا تاخیر کی صورت میں تادیبی کارروائی کی جائے گی۔</p>
    <p style={{ margin: 0 }}>4۔ یہ ہدایت میڈیکل سپرنٹنڈنٹ کے حکم پر جاری کی گئی۔</p>
  </div>

  {/* Signature Section - Bottom Left */}
  <div style={{ width: "35%", textAlign: "center", fontWeight: "bold", fontSize: "12px", marginTop: "300px" }}>
    <div
      style={{
        borderTop: "1px solid #000",
        width: "200px",
        margin: "0 auto 8px auto",
      }}
    ></div>
    <p style={{ margin: 0 }}>میڈیکل سپرنٹنڈنٹ</p>
    <p style={{ margin: 0 }}>راولپنڈی انسٹیٹیوٹ آف کارڈیالوجی</p>
  </div>
</div>



  {/* Screenshot Button */}
  {/* <div style={{ marginTop: 40, textAlign: "center" }}>
   <button
  ref={urduButtonRef}
  onClick={() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0]; // e.g., 2025-07-07
    handleScreenshotWithoutButton(
      urduRef,
      urduButtonRef,
      `AMS_URDU_${formattedDate}.pdf`
    );
  }}
  style={btnStyle}
>
  📄 پی ڈی ایف ایکسپورٹ کریں
</button>
  </div> */}

</div>






 {/* English Table Section */}
<div
  ref={englishRef}
  style={{
    background: "#fff",
    padding: "20px 30px",
    borderRadius: "10px",
    position: "relative",
    fontFamily: "Arial, sans-serif",
    width: "794px", // A4 portrait width in px (≈210mm)
    minHeight: "1123px", // A4 height in px (≈297mm)
    margin: "auto",
    boxShadow: "0 0 10px rgba(0,0,0,0.2)",
    fontSize: "12px",
  }}
>
  {/* English Header */}
  <div
    style={{
      backgroundColor: "#e9f2ff",
      border: "2px solid #0d6efd",
      padding: "15px",
      borderRadius: "10px",
      marginBottom: "20px",
      position: "relative",
      textAlign: "center",
      color: "#000",
      fontWeight: "bold",
    }}
  >
    <img
      src={logoRight}
      alt="right"
      style={{ height: 60, position: "absolute", top: 10, right: 20 }}
    />
    <img
      src={logoLeft}
      alt="left"
      style={{ height: 60, position: "absolute", top: 10, left: 20 }}
    />
    <h3 style={{ marginTop: 0, fontSize: "18px" }}>
      Office of the Medical Superintendent
    </h3>
    <p style={{ margin: 0 }}>Rawalpindi Institute of Cardiology, Rawal Road, Rawalpindi</p>
    <p style={{ margin: "5px 0" }}>No: RIC/Admin/ ____________/2025</p>
    <p style={{ margin: "5px 0" }}>Dated: ___ / ___ / 2025</p>
  </div>

  {/* Title */}
  <div
    style={{
      backgroundColor: "#d1e7dd",
      border: "1px solid #198754",
      padding: "10px",
      borderRadius: "8px",
      textAlign: "center",
      marginBottom: "20px",
      color: "#0f5132",
    }}
  >
    <h4 style={{ fontWeight: "bold", fontSize: "16px", margin: 0 }}>
      AMS / APWMO Evening Duty Roaster
    </h4>
    <p style={{ margin: "5px 0", fontSize: "14px" }}>📅 {readableDate}</p>
  </div>

  {/* Table */}
  <table
  style={{
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "10px",
    tableLayout: "fixed",
  }}
>
  <thead style={{ backgroundColor: "#0d6efd", color: "#fff" }}>
    <tr>
      {/* First Column Set */}
      <th style={{ width: "30px", border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>#</th>
      <th style={{ width: "90px", border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>Date</th>
      <th style={{ width: "80px", border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>Day</th>
      <th style={{ width: "166px", border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>Evening</th>

      {/* Second Column Set */}
      <th style={{ width: "30px", border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>#</th>
      <th style={{ width: "90px", border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>Date</th>
      <th style={{ width: "80px", border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>Day</th>
      <th style={{ width: "166px", border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>Evening</th>
    </tr>
  </thead>
  <tbody>
    {loading ? (
      <tr>
        <td colSpan="8" style={{ textAlign: "center", padding: "20px" }}>
          Loading...
        </td>
      </tr>
    ) : (
      renderDoubleTableRows(paginatedEnglish)
    )}
  </tbody>
</table>


{/* Footer Note */}
<div
  style={{
    padding: "0 30px",
    fontSize: "11px",
    lineHeight: "1.7",
    marginTop: "50px",
  }}
>
  <p style={{ fontWeight: "bold", marginBottom: "8px" }}>Note:</p>
  <p style={{ margin: 0 }}>1- This duty roaster is tentative and subject to change without prior notice by the administration.</p>
  <p style={{ margin: 0 }}>2- All staff are instructed to strictly follow the assigned duties.</p>
  <p style={{ margin: 0 }}>3- Absence or delay during duty hours will result in disciplinary action.</p>
  <p style={{ margin: 0 }}>4- Issued under the directive of the Medical Superintendent.</p>
</div>

{/* Signature Section */}
<div
  style={{
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "12px",
    marginTop: "150px",
    paddingRight: "30px",
    display: "flex",
    justifyContent: "flex-end",
  }}
>
  <div>
    <div
      style={{
        borderTop: "1px solid #000",
        width: "200px",
        margin: "0 auto 8px auto",
      }}
    ></div>
    <p style={{ margin: 0 }}>Medical Superintendent</p>
    <p style={{ margin: 0 }}>Rawalpindi Institute of Cardiology</p>
  </div>
</div>



  {/* Button */}
  {/* <div style={{ marginTop: 40, textAlign: "center" }}>
    <button
  ref={englishButtonRef}
  onClick={() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0]; // e.g., 2025-07-07
    handleScreenshotWithoutButton(
      englishRef,
      englishButtonRef,
      `AMS_ENGLISH_${formattedDate}.pdf`
    );
  }}
  style={btnStyle}
>
  📄 Export PDF
</button>
  </div> */}

</div>



      {/* Pagination Controls */}
      <div style={{ marginTop: 30, textAlign: "center" }}>
        <button onClick={handlePrev} disabled={currentPage === 1} style={btnStyle}>⬅️ Prev</button>
        <span style={{ margin: "0 15px" }}>Page {currentPage} of {totalPages}</span>
        <button onClick={handleNext} disabled={currentPage === totalPages} style={btnStyle}>Next ➡️</button>
      </div>
    </div>
  );
};

const btnStyle = {
  backgroundColor: "#0d6efd",
  color: "#fff",
  padding: "8px 16px",
  border: "none",
  borderRadius: "6px",
  fontSize: "15px",
  cursor: "pointer"
};

export default UrduPDFExport;
